import {
  paymentBatchesResponseSchema,
  type PaymentBatchesResponse,
  type PaymentStatus,
  type PaymentBatch,
} from '../types';
import { ApiClientError } from '@/errors';

// Mock data for payment batches
const mockPaymentBatches: PaymentBatch[] = [
  {
    batchId: 'batch-001',
    batchNumber: 'PAY-2026-001',
    status: 'completed',
    paymentMethod: 'bank_transfer',
    currency: 'USD',
    totalAmount: 45250.0,
    invoiceCount: 5,
    items: [
      {
        invoiceId: 'inv-001',
        invoiceNumber: 'INV-2026-0001',
        supplierId: 'sup-001',
        supplierName: 'Ocean Fresh Seafood',
        amount: 12500.0,
        currency: 'USD',
        dueDate: '2026-01-15',
      },
      {
        invoiceId: 'inv-002',
        invoiceNumber: 'INV-2026-0002',
        supplierId: 'sup-002',
        supplierName: 'Premium Meats Co',
        amount: 8750.0,
        currency: 'USD',
        dueDate: '2026-01-15',
      },
      {
        invoiceId: 'inv-003',
        invoiceNumber: 'INV-2026-0003',
        supplierId: 'sup-003',
        supplierName: 'Fresh Produce Direct',
        amount: 6200.0,
        currency: 'USD',
        dueDate: '2026-01-18',
      },
      {
        invoiceId: 'inv-004',
        invoiceNumber: 'INV-2026-0004',
        supplierId: 'sup-004',
        supplierName: 'Dairy Delights',
        amount: 9800.0,
        currency: 'USD',
        dueDate: '2026-01-20',
      },
      {
        invoiceId: 'inv-005',
        invoiceNumber: 'INV-2026-0005',
        supplierId: 'sup-005',
        supplierName: 'Dry Goods Wholesale',
        amount: 8000.0,
        currency: 'USD',
        dueDate: '2026-01-22',
      },
    ],
    scheduledDate: '2026-01-25',
    processedDate: '2026-01-25',
    createdBy: 'John Smith',
    approvedBy: 'Sarah Johnson',
    createdAt: '2026-01-20T10:00:00Z',
    updatedAt: '2026-01-25T14:30:00Z',
  },
  {
    batchId: 'batch-002',
    batchNumber: 'PAY-2026-002',
    status: 'processing',
    paymentMethod: 'wire',
    currency: 'EUR',
    totalAmount: 28400.0,
    invoiceCount: 3,
    items: [
      {
        invoiceId: 'inv-006',
        invoiceNumber: 'INV-2026-0006',
        supplierId: 'sup-006',
        supplierName: 'Mediterranean Imports',
        amount: 15200.0,
        currency: 'EUR',
        dueDate: '2026-02-01',
      },
      {
        invoiceId: 'inv-007',
        invoiceNumber: 'INV-2026-0007',
        supplierId: 'sup-007',
        supplierName: 'Spanish Olive Co',
        amount: 7800.0,
        currency: 'EUR',
        dueDate: '2026-02-03',
      },
      {
        invoiceId: 'inv-008',
        invoiceNumber: 'INV-2026-0008',
        supplierId: 'sup-008',
        supplierName: 'French Wines Ltd',
        amount: 5400.0,
        currency: 'EUR',
        dueDate: '2026-02-05',
      },
    ],
    scheduledDate: '2026-02-05',
    processedDate: null,
    createdBy: 'John Smith',
    approvedBy: 'Sarah Johnson',
    createdAt: '2026-01-28T09:00:00Z',
    updatedAt: '2026-02-01T11:00:00Z',
  },
  {
    batchId: 'batch-003',
    batchNumber: 'PAY-2026-003',
    status: 'pending_approval',
    paymentMethod: 'ach',
    currency: 'USD',
    totalAmount: 18750.0,
    invoiceCount: 4,
    items: [
      {
        invoiceId: 'inv-009',
        invoiceNumber: 'INV-2026-0009',
        supplierId: 'sup-001',
        supplierName: 'Ocean Fresh Seafood',
        amount: 5500.0,
        currency: 'USD',
        dueDate: '2026-02-10',
      },
      {
        invoiceId: 'inv-010',
        invoiceNumber: 'INV-2026-0010',
        supplierId: 'sup-009',
        supplierName: 'Bakery Supplies Inc',
        amount: 4250.0,
        currency: 'USD',
        dueDate: '2026-02-12',
      },
      {
        invoiceId: 'inv-011',
        invoiceNumber: 'INV-2026-0011',
        supplierId: 'sup-010',
        supplierName: 'Spice World Trading',
        amount: 3800.0,
        currency: 'USD',
        dueDate: '2026-02-14',
      },
      {
        invoiceId: 'inv-012',
        invoiceNumber: 'INV-2026-0012',
        supplierId: 'sup-003',
        supplierName: 'Fresh Produce Direct',
        amount: 5200.0,
        currency: 'USD',
        dueDate: '2026-02-15',
      },
    ],
    scheduledDate: '2026-02-15',
    processedDate: null,
    createdBy: 'Mike Wilson',
    approvedBy: null,
    createdAt: '2026-02-01T08:30:00Z',
    updatedAt: '2026-02-01T08:30:00Z',
  },
  {
    batchId: 'batch-004',
    batchNumber: 'PAY-2026-004',
    status: 'draft',
    paymentMethod: 'bank_transfer',
    currency: 'USD',
    totalAmount: 32100.0,
    invoiceCount: 6,
    items: [
      {
        invoiceId: 'inv-013',
        invoiceNumber: 'INV-2026-0013',
        supplierId: 'sup-002',
        supplierName: 'Premium Meats Co',
        amount: 9200.0,
        currency: 'USD',
        dueDate: '2026-02-20',
      },
      {
        invoiceId: 'inv-014',
        invoiceNumber: 'INV-2026-0014',
        supplierId: 'sup-004',
        supplierName: 'Dairy Delights',
        amount: 6800.0,
        currency: 'USD',
        dueDate: '2026-02-22',
      },
      {
        invoiceId: 'inv-015',
        invoiceNumber: 'INV-2026-0015',
        supplierId: 'sup-005',
        supplierName: 'Dry Goods Wholesale',
        amount: 4500.0,
        currency: 'USD',
        dueDate: '2026-02-22',
      },
      {
        invoiceId: 'inv-016',
        invoiceNumber: 'INV-2026-0016',
        supplierId: 'sup-011',
        supplierName: 'Beverage Distributors',
        amount: 5100.0,
        currency: 'USD',
        dueDate: '2026-02-25',
      },
      {
        invoiceId: 'inv-017',
        invoiceNumber: 'INV-2026-0017',
        supplierId: 'sup-012',
        supplierName: 'Frozen Foods Express',
        amount: 3800.0,
        currency: 'USD',
        dueDate: '2026-02-25',
      },
      {
        invoiceId: 'inv-018',
        invoiceNumber: 'INV-2026-0018',
        supplierId: 'sup-001',
        supplierName: 'Ocean Fresh Seafood',
        amount: 2700.0,
        currency: 'USD',
        dueDate: '2026-02-28',
      },
    ],
    scheduledDate: '2026-02-28',
    processedDate: null,
    createdBy: 'John Smith',
    approvedBy: null,
    createdAt: '2026-02-02T10:15:00Z',
    updatedAt: '2026-02-02T10:15:00Z',
  },
  {
    batchId: 'batch-005',
    batchNumber: 'PAY-2026-005',
    status: 'failed',
    paymentMethod: 'wire',
    currency: 'GBP',
    totalAmount: 12800.0,
    invoiceCount: 2,
    items: [
      {
        invoiceId: 'inv-019',
        invoiceNumber: 'INV-2026-0019',
        supplierId: 'sup-013',
        supplierName: 'British Tea Company',
        amount: 7300.0,
        currency: 'GBP',
        dueDate: '2026-01-28',
      },
      {
        invoiceId: 'inv-020',
        invoiceNumber: 'INV-2026-0020',
        supplierId: 'sup-014',
        supplierName: 'Scottish Salmon Ltd',
        amount: 5500.0,
        currency: 'GBP',
        dueDate: '2026-01-30',
      },
    ],
    scheduledDate: '2026-01-30',
    processedDate: null,
    createdBy: 'Sarah Johnson',
    approvedBy: 'Sarah Johnson',
    notes: 'Payment failed due to incorrect bank details. Awaiting supplier update.',
    createdAt: '2026-01-25T14:00:00Z',
    updatedAt: '2026-01-30T16:45:00Z',
  },
];

export interface PaymentBatchFilters {
  readonly status?: PaymentStatus;
  readonly currency?: string;
}

export async function getPaymentBatches(
  filters?: PaymentBatchFilters
): Promise<PaymentBatchesResponse> {
  // Simulate API delay
  await new Promise((resolve) => setTimeout(resolve, 500));

  const filteredBatches = mockPaymentBatches
    .filter((b) => !filters?.status || b.status === filters.status)
    .filter((b) => !filters?.currency || b.currency === filters.currency);

  const response = {
    data: filteredBatches,
    pagination: {
      nextToken: null,
      totalCount: filteredBatches.length,
    },
    meta: {
      totalPending: mockPaymentBatches
        .filter((b) => b.status === 'pending_approval')
        .reduce((sum, b) => sum + b.totalAmount, 0),
      totalProcessing: mockPaymentBatches
        .filter((b) => b.status === 'processing')
        .reduce((sum, b) => sum + b.totalAmount, 0),
      totalCompleted: mockPaymentBatches
        .filter((b) => b.status === 'completed')
        .reduce((sum, b) => sum + b.totalAmount, 0),
    },
  };

  return paymentBatchesResponseSchema.parse(response);
}

export async function approvePaymentBatch(batchId: string): Promise<PaymentBatch> {
  await new Promise((resolve) => setTimeout(resolve, 300));
  
  const batch = mockPaymentBatches.find((b) => b.batchId === batchId);
  if (!batch) {
    throw new ApiClientError(404, 'NOT_FOUND', 'Payment batch not found');
  }
  
  return {
    ...batch,
    status: 'approved',
    approvedBy: 'Current User',
    updatedAt: new Date().toISOString(),
  };
}

export async function processPaymentBatch(batchId: string): Promise<PaymentBatch> {
  await new Promise((resolve) => setTimeout(resolve, 300));
  
  const batch = mockPaymentBatches.find((b) => b.batchId === batchId);
  if (!batch) {
    throw new ApiClientError(404, 'NOT_FOUND', 'Payment batch not found');
  }
  
  return {
    ...batch,
    status: 'processing',
    updatedAt: new Date().toISOString(),
  };
}
